import {queryCache, useMutation} from 'react-query';
import {client} from './ApiClient';
import {mapCustomCodes} from "../Helpers/Functions";

const joinClub = ({urls, session, domain, deviceCode, data, clubUid}: {urls: any; session: string; domain: string; deviceCode: string; data: any; clubUid: any;}) => {
	const body = {
		...data,
		GiftCustomer: data.GiftCustomer === null ? null : {
			...data.GiftCustomer,
			CustomFields: mapCustomCodes(data.GiftCustomer.CustomFields),
			Address: {
				...data.GiftCustomer
			}
		},
		StartDate: data.StartDate ? data.StartDate.format('YYYY-MM-DD') : null,
		ExpirationDate: data.ExpirationDate ? data.ExpirationDate.format('YYYY-MM-DD') : null,
		ClubUid: clubUid,
	}
	return client(urls.LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/sessions/${session}/clubmembership/commands/join`, {
		body: body
	});
}

export default function useJoinClub() {
	// @ts-ignore
	return useMutation(joinClub, {
		onSuccess: () => {
			queryCache.invalidateQueries('ClubMembership')
		},
	})
}